import styled from '@emotion/styled'

export const TimeLineStepCont = styled.div((props) => ({

  '.ui.label > .icon':{
    margin:0
  },
  '.ui.circular.label':{
    padding:'0.5833rem 0.833rem'
  },

  'section>div:first-child':{
    paddingLeft: '0 !important'
  },

  'section>div':{
    paddingLeft: '2.4rem !important',
    margin:'0 !important'
  },

  'section':{
    'section':{
      margin:'0 !important'
    },
  },

  '.displayName':{
    display:'flex',
    flexDirection:'column',
    '>div:last-child':{
      fontWeight:'normal'
    }
  },

  '.tlCon':{
    '>div:last-child':{
      boxShadow:'none !important'
    }
  }


}))



